import React from "react";
import SignInLayer from "../components/SignInLayer";
import SignUpLayer from "../components/SignUpLayer"

const SignInPage = () => {
  return <SignUpLayer />;
};

export default SignInPage;
